import { render, staticRenderFns } from "./elderlyWarningDetails.vue?vue&type=template&id=128f0da0&scoped=true"
import script from "./elderlyWarningDetails.vue?vue&type=script&lang=js"
export * from "./elderlyWarningDetails.vue?vue&type=script&lang=js"
import style0 from "./elderlyWarningDetails.vue?vue&type=style&index=0&id=128f0da0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128f0da0",
  null
  
)

export default component.exports